import { IItemSentence } from '../models/i-item-sentence';
export const InputSequenceList: IItemSentence[] = [];
